import { render, staticRenderFns } from "./Rch.vue?vue&type=template&id=512358d9&scoped=true&"
import script from "./Rch.vue?vue&type=script&lang=js&"
export * from "./Rch.vue?vue&type=script&lang=js&"
import style0 from "./Rch.vue?vue&type=style&index=0&id=512358d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512358d9",
  null
  
)

export default component.exports